module.exports = __webpack_public_path__ + "img/dbCorte2.9ea8bbcf.jpg";